// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1-sXc","container":"style_container__1JSnJ","crumbItem":"style_crumbItem__JcuHq","pad5":"style_pad5__2r-Ok","segmentTitle":"style_segmentTitle__3hwPu"};